import React, {useEffect} from "react";
import {useTranslation} from "next-i18next";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {useRouter} from "next/router";
import {useModalRouting} from "../../utils/useModalRouting";
import {
  fetchCampaigns,
  reset,
  selectCampaigns,
  selectCurrentPage,
  selectError,
  selectIsLoading,
  setCurrentPage
} from "../../redux/campaign/campaignListSlice";
import {ApiError} from "../../errors/apiError";
import {RealmServiceError} from "../../errors/realmServiceError";
import {Container} from "../containers/Container";
import {StoreEmptyStateView} from "../storeFeed/StoreEmptyStateView";
import {WarningColorIcon} from "../icons";
import {HeroHeading2} from "../text";
import Link from "next/link";
import {Button} from "../buttons/Button";
import {CampaignsTable} from "./CampaignsTableView";

export const CampaignsView: React.FC<any> = () => {
  const { t } = useTranslation()

  const dispatch = useAppDispatch()
  const router = useRouter()
  const { createRoute } = useModalRouting()

  const pageNumber = useAppSelector(selectCurrentPage)
  const campaigns = useAppSelector(selectCampaigns)
  const error = useAppSelector(selectError)
  const isLoading = useAppSelector(selectIsLoading)

  useEffect(() => {
    dispatch(reset())
  }, [dispatch])

  useEffect(() => {
    dispatch(fetchCampaigns(pageNumber))
  }, [dispatch, pageNumber])

  const emptyStateButtonTitle = error instanceof ApiError && error.code === 'UNAUTHORIZED' || error instanceof RealmServiceError && error.code === 'NOT_LOGGED_IN'
    ? t('store:store_empty_state_button_go_back')
    : t('store:store_empty_state_button_try_again')

  return <Container>
    <div className={`${error ? '' : 'hidden'} flex-1 flex flex-col justify-center items-center`}>
      <StoreEmptyStateView
        onClick={() => {
          if (error instanceof ApiError && error.code === 'UNAUTHORIZED' || error instanceof RealmServiceError && error.code === 'NOT_LOGGED_IN') {
            router.back()
          } else {
            dispatch(reset())
            if (pageNumber === 1) {
              dispatch(fetchCampaigns(pageNumber))
            } else {
              dispatch(setCurrentPage(1))
            }
          }
        }}
        buttonTitle={emptyStateButtonTitle}
        error={error}
        icon={<WarningColorIcon />}
        isLoading={isLoading}
      />
    </div>

    <div className={`mb-8 ${error ? 'hidden' : ''} flex space-x-4`}>
      <HeroHeading2 className={`flex-grow`}>Campaigns</HeroHeading2>

      <div className="flex-shrink-0">
        <Link
          href={createRoute({ name: 'campaign_detail', query: { campaign_id: '' }, returnTo: '/admin/campaigns' })}
          shallow={true}
          passHref
        >
          <a>
            <Button
              buttonStyle="primary"
            >Create Campaign</Button>
          </a>
        </Link>
      </div>
    </div>

    <div className={`mb-8 ${error ? 'hidden' : ''}`}>
      <CampaignsTable
        campaigns={campaigns}
        onLoadMoreClicked={() => {
          dispatch(setCurrentPage(pageNumber + 1))
        }}
      />
    </div>
  </Container>
}